<div *ngIf="localService.languageContent && localService.languageContent.billing">
    <div *ngIf="wrappers && wrappers.productCategories && wrappers.productCategories.length > 0" style="position: fixed;
   width: calc(100% - 40px); z-index: 20; background-color: white;" class="center">
        <ngx-select [(ngModel)]="selectedCategory" [noAutoComplete]="true" [items]="wrappers.productCategories"
            [optionValueField]="'key'" [optionTextField]="'v1'" (select)="onSegregateItems()">
        </ngx-select>
    </div>
    <div style="margin-bottom: 30px;">
        &nbsp;
    </div>
    <div *ngFor="let segregatedItem of segregatedItems; index as i" class="row" (window:resize)="onResize($event)">
        <div *ngFor="let item of segregatedItem; index as j" class="item-tile" [ngClass]="classNameRow">
            <div class="banner" [ngClass]="item.value ? 'selected' : ''">
                <div class="item-details">
                    <div class="row">
                        <div class="wrap-div col-12" title="{{item.v1}}">
                            <label class="en" *ngIf="itemsDisplayType != 2">{{item.v4}}&nbsp;-&nbsp;</label>
                            <label [ngClass]="localService.getLanguageCode(item.v2)"
                                (click)="onAction(2,item.key)">{{item.v1}}</label>
                        </div>
                    </div>
                    <div *ngIf="item.v6" class="wrap-div" title="{{item.v6}}" style="margin-left: -10px;">
                        <label style="font-weight: normal;"
                            [ngClass]="localService.getLanguageCode(item.v7)">{{item.v6}}</label>
                    </div>
                    <div class="row" *ngIf="!(itemsDisplayType == 2 || (businessId && businessId != item.v9))">
                        <div class="col-6">
                            <div class="wrap-div" style="text-align: left; margin-top: 5px;">
                                <span class="en search_price">{{item.v3 | number: '1.2-2'}}</span>
                            </div>
                        </div>
                        <div class="col-6" style="text-align: right;">
                            <button class="button_icon button_icon_color icon_adjust" style="color:red"
                                [disabled]="!item.value || item.value <= 0"
                                (click)="onAdjustQuickQty(1,item.key,item.value,i)">remove_circle_outline</button>
                            <span style="margin: 0 10px;">{{item.value || 0}}</span>
                            <button class="button_icon button_icon_color icon_adjust" style="color:darkgreen"
                                (click)="onAdjustQuickQty(2,item.key,item.value,i)">add_circle_outline</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div style="height: 150px;">
        &nbsp;
    </div>
    <div class="footer">
        <div style="display: flex;">
            <div>
                <input autocomplete="off" type="text" style="margin-bottom: 10px;max-width: 200px;"
                    [(ngModel)]="searchKey" title="{{localService.languageContent.common.search}}"
                    placeholder="{{localService.languageContent.common.search}}" (keyup)="onSegregateItems()" />
            </div>
            <div style="flex: 1 1 auto;">
                <button class="btn btn-primary" (click)="onAction(3)"
                    [disabled]="!(cartSession && cartSession.BusinessId && cartSession.ProductIdQuantity.length > 0)">
                    {{localService.languageContent.common.submit}}
                    <span class="en">&nbsp;({{cartSession && cartSession.BusinessId ?
                        cartSession.ProductIdQuantity.length :
                        0}})</span>
                </button>
            </div>
        </div>
    </div>
    <span style="display:none;">
        <input type="button" class="on_login_success" (click)="onGetCartSession(true)" />
    </span>
    <div>
        <app-summary-details [(isOpenPopup)]="isSummaryDetailPopupOpen" [id]="selectedSummaryId"
            [summaryType]="selectedSummaryType" [ctryCode]="countryCode"
            (onClose)="onClosesSummaryDetailsPopup($event)"></app-summary-details>
    </div>